import { FormEvent, useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";

import { updateUser } from "../../actions/UserManagement";

function ViewUser() {
    const location = useLocation();
    const initialUser = location.state?.user;
    const [user, setUser] = useState(initialUser);
    const [isCollapsed, setIsCollapsed] = useState(true);

    const [fullName, setFullName] = useState(user.name);
    const [email, setEmail] = useState(user.email);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [message, setMessage] = useState<string | null>(null);
    const [messageType, setMessageType] = useState<'success' | 'error' | null>(null);

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        try {
            const response = await updateUser(user.id, fullName, email, password, confirmPassword);

            if (response.status === 200) {
                const updatedUser = response.data.user;

                setUser(updatedUser);
                setFullName(updatedUser.name);
                setEmail(updatedUser.email);
                setPassword('');
                setConfirmPassword('');
                setMessage("Profile updated successfully.");
                setMessageType('success');
            } else {
                setMessage("Failed to update profile.");
                setMessageType('error');
            }
        } catch (error) {
            console.error('Update failed:', error);
            setMessage("An error occurred while updating the profile.");
            setMessageType('error');
        }

        setTimeout(() => {
            setMessage(null);
            setMessageType(null);
        }, 5000);
    }

    function resetFields() {
        setFullName(user.name);
        setEmail(user.email);
        setPassword('');
        setConfirmPassword('');
    }

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>
            <div className="forgot-password-container">
                <div className="forgot-password-inner">
                    <div className="site-grid" style={{ width: '100%' }}>
                        <div className="item item-double-content">
                            <div className="item-inner"></div>
                            <div className="item-inner item-inner-content">
                                <div className="content">
                                    <div className="content-title">
                                        <h2 className="content-title-small">Edit Profile</h2>
                                    </div>
                                    <div className="content-text">
                                        <p className='content-text'>View and update your profile.</p>
                                    </div>

                                    {message && (
                                        <div className={`message ${messageType}`}>
                                            {message}
                                        </div>
                                    )}

                                    <form className="content-form" onSubmit={handleSubmit}>
                                        <div className="content-form-field">
                                            <input
                                                type="text"
                                                className="input-email"
                                                placeholder="Full Name"
                                                value={fullName}
                                                onChange={(e) => setFullName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="content-form-field">
                                            <input
                                                type="text"
                                                className="input-email"
                                                placeholder="Email Address"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="content-form-field">
                                            <input
                                                type="password"
                                                className="input-email"
                                                placeholder="Password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="content-form-field">
                                            <input
                                                type="password"
                                                className="input-email"
                                                placeholder="Confirm Password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                        </div>

                                        <div className="button-row">
                                            <div className="content-form-button">
                                                <button className="button button-wide" type="button" onClick={resetFields}>Reset</button>
                                            </div>
                                            <div className="content-form-button">
                                                <button className="button button-wide" type="submit">Submit</button>
                                            </div>
                                        </div>

                                        <div className="content-next"></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewUser;
